/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';
import dayjs from 'dayjs';

import { DateInput, Form } from '@mairistem/composants';

import type { OptionCodeAnts } from '@/types';

interface MentionFormFieldsProps {
  data?: Record<string, any>;
  optionsCodeAnts?: OptionCodeAnts[];
  onChange: (
    event: React.SyntheticEvent | null,
    payload: { name: string; value: unknown },
  ) => void;
}

export const estMentionValide = (data?: Record<string, any>) =>
  !_.isEmpty(_.trim(_.toString(data?.numero ?? ''))) &&
  !_.isEmpty(_.trim(_.toString(data?.dateApposition ?? ''))) &&
  !_.isEmpty(_.trim(_.toString(data?.titre ?? '')));

const MentionFormFields = (props: MentionFormFieldsProps) => {
  const { data, optionsCodeAnts, onChange } = props;

  const handleNumeroChange = React.useCallback(
    (
      event: React.SyntheticEvent | null,
      payload: { name: string; value: string },
    ) => {
      onChange(event, {
        name: 'numero',
        value: payload.value.replace(/[^0-9]/g, ''),
      });
    },
    [onChange],
  );

  const handleDateChange = React.useCallback(
    (date: Date | string | undefined) => {
      onChange(null, {
        name: 'dateApposition',
        value: date ? dayjs(date).format('YYYY-MM-DD') : null,
      });
    },
    [onChange],
  );

  return (
    // @ts-ignore
    <Form>
      <Form.Group>
        <Form.Input
          required
          width={8}
          label="Numéro"
          name="numero"
          value={data?.numero ?? ''}
          onChange={handleNumeroChange}
        />
        <Form.Field required width={8}>
          <label>Date apposition</label>
          <DateInput
            value={
              data?.dateApposition
                ? dayjs(data.dateApposition).toDate()
                : undefined
            }
            onChange={handleDateChange}
          />
        </Form.Field>
      </Form.Group>
      <Form.Input
        required
        fluid
        label="Titre"
        name="titre"
        value={data?.titre ?? ''}
        onChange={onChange}
      />
      <Form.TextArea
        label="Texte"
        name="texte"
        rows={5}
        value={data?.texte ?? ''}
        onChange={onChange}
      />
      <Form.Dropdown
        selection
        clearable
        fluid
        search
        upward
        selectOnBlur={false}
        label="Code ANTS"
        name="codeMentionAnts"
        options={optionsCodeAnts}
        value={data?.codeMentionAnts ?? ''}
        onChange={onChange}
      />
    </Form>
  );
};

export default MentionFormFields;
